import makeDebug from 'debug'
import { Url } from '../libs/url'

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_MINICART_DATA = 'UPDATE_MINICART_DATA'
export const UPDATE_MINIWISHLIST_DATA = 'UPDATE_MINIWISHLIST_DATA'

export const SHOW_OVERLAY = 'SHOW_OVERLAY'
export const HIDE_OVERLAY = 'HIDE_OVERLAY'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'

export const UPDATE_NAVIGATION_MENU = 'UPDATE_NAVIGATION_MENU'

export const UPDATE_NAVIGATION_PANEL = 'UPDATE_NAVIGATION_PANEL'

export const UPDATE_URL = 'UPDATE_URL'
export const UPDATE_SIDEBAR_OVERLAY = 'UPDATE_SIDEBAR_OVERLAY'
export const UPDATE_UI_BODY = 'UPDATE_UI_BODY'
export const UPDATE_MODAL_NAME = 'UPDATE_MODAL_NAME'
export const UPDATE_VIEW_TYPE_DEVICE = 'UPDATE_VIEW_TYPE_DEVICE'
export const UPDATE_HEADER_PROMO = 'UPDATE_HEADER_PROMO'
export const UPDATE_NEWSLETTER_COUNTER = 'UPDATE_NEWSLETTER_COUNTER'

export const UPDATE_NO_ECOMMERCE_COUNTER = 'UPDATE_NO_ECOMMERCE_COUNTER'
export const UPDATE_LAST_WISHLIST_ITEM = 'UPDATE_LAST_WISHLIST_ITEM'
export const UPDATE_LAST_ADDTOBAG_ITEM = 'UPDATE_LAST_ADDTOBAG_ITEM'

export const SHOW_PICKUPSTORE = 'SHOW_PICKUPSTORE'
export const HIDE_PICKUPSTORE = 'HIDE_PICKUPSTORE'

export const SET_USER_SELF_DATA = 'SET_USER_SELF_DATA'
export const UPDATE_GOOGLE_MAP_DATA = 'UPDATE_GOOGLE_MAP_DATA'

export const UPDATE_FRAME_ADVISOR_STATUS = 'UPDATE_FRAME_ADVISOR_STATUS'

export const OPEN_FIND_IN_STORE_PANEL = 'OPEN_FIND_IN_STORE_PANEL'
export const CLOSE_FIND_IN_STORE_PANEL = 'CLOSE_FIND_IN_STORE_PANEL'

export const OPEN_STORE_DETAILS_PANEL = 'OPEN_STORE_DETAILS_PANEL'
export const CLOSE_STORE_DETAILS_PANEL = 'CLOSE_STORE_DETAILS_PANEL'

export const OPEN_EYEMED_MODAL_OR_PANEL = 'OPEN_EYEMED_MODAL_OR_PANEL'
export const CLOSE_EYEMED_MODAL_OR_PANEL = 'CLOSE_EYEMED_MODAL_OR_PANEL'

export const OPEN_PAY_OVER_TIME_MODAL_OR_PANEL = 'OPEN_PAY_OVER_TIME_MODAL_OR_PANEL'
export const CLOSE_PAY_OVER_TIME_MODAL_OR_PANEL = 'CLOSE_PAY_OVER_TIME_MODAL_OR_PANEL'
export const UPDATE_PDP_DASH_BUTTON_SMALL = 'UPDATE_PDP_DASH_BUTTON_SMALL'
export const UPDATE_NEWSLETTER_OPEN_STATUS = 'UPDATE_NEWSLETTER_OPEN_STATUS'

export const OPEN_AFTERPAY_MODAL_OR_PANEL = 'OPEN_AFTERPAY_MODAL_OR_PANEL'
export const CLOSE_AFTERPAY_MODAL_OR_PANEL = 'CLOSE_AFTERPAY_MODAL_OR_PANEL'

export const LOCK_TRUST_PILOT_SCRIPT = 'LOCK_TRUST_PILOT_SCRIPT'

export const SET_GOOGLE_MAPS_SCRIPTS_STATUS = 'SET_GOOGLE_MAPS_SCRIPTS_STATUS'

export const ACTION_SET_PICKUP_STORE_TRUE = 'ACTION_SET_PICKUP_STORE_TRUE'

export const SHOW_PAYMENT_MESSAGE_BOX = 'SHOW_PAYMENT_MESSAGE_BOX'
export const HIDE_PAYMENT_MESSAGE_BOX = 'HIDE_PAYMENT_MESSAGE_BOX'

export const UPDATE_KLARNA_EXPRESS_LOADED_STATUS = 'UPDATE_KLARNA_EXPRESS_LOADED_STATUS'

export const UPDATE_KLARNA_EXPRESS_INITIALIZED = 'UPDATE_KLARNA_EXPRESS_INITIALIZED'
export const UPDATE_ROX_PANEL_OVERLAY = 'UPDATE_ROX_PANEL_OVERLAY'

const debug = makeDebug('store:mutation')

export const mutations = {
  [UPDATE_USER_DATA]: function (state, payload) {
    state.user = Object.assign({}, state.user, { ...payload, loaded: true })
  },
  [UPDATE_MINICART_DATA]: function (state, payload) {
    debug('%s payload %o', UPDATE_MINICART_DATA, payload)
    state.sidebar.cart = Object.assign({}, state.sidebar.cart, { ...payload })
  },
  [UPDATE_MINIWISHLIST_DATA]: function (state, payload) {
    debug('%s payload %o', UPDATE_MINIWISHLIST_DATA, payload)
    state.sidebar.wishlist = Object.assign({}, state.sidebar.wishlist, { ...payload })
  },
  [SHOW_OVERLAY]: function (state) {
    state.overlay = true
  },
  [HIDE_OVERLAY]: function (state) {
    state.overlay = false
  },
  [TOGGLE_OVERLAY]: function (state) {
    state.overlay = !state.overlay
  },

  // TODO: remove these two mutations, or find a common logic
  [UPDATE_NAVIGATION_MENU]: function (state, payload) {
    state.navigationMenu = Object.assign({}, state.navigationMenu, { ...payload })
  },
  [UPDATE_NAVIGATION_PANEL]: function (state, payload) {
    state.navigationMenu = Object.assign({}, state.navigationMenu, { showPanel: payload })
  },

  [UPDATE_URL]: function (state, payload) {
    Url.updateUrl(payload)
  },
  [UPDATE_SIDEBAR_OVERLAY]: function (state, payload) {
    state.sidebar = Object.assign({}, state.sidebar, payload)
  },
  [UPDATE_UI_BODY]: function (state, payload) {
    const key = Object.keys(payload)
    key.forEach((e) => {
      document.body.style[e] = payload[e]
    })
    state.ui.body = Object.assign({}, state.ui.body, payload)
  },

  [UPDATE_MODAL_NAME]: function (state, name) {
    state.openModalName = name
  },
  [UPDATE_VIEW_TYPE_DEVICE]: function (state, value) {
    state.ui.isDesktop = value
  },
  [UPDATE_HEADER_PROMO]: function (state, payload) {
    const active = payload && payload.active
    if ('string' === typeof active && 'true' === active.toLowerCase()) {
      state.ui.isHeaderPromo = true
    } else if ('boolean' === typeof active && active) {
      state.ui.isHeaderPromo = active
    }
  },
  [UPDATE_NEWSLETTER_COUNTER]: function (state) {
    state.newsletter.submitCounter += 1
  },
  [UPDATE_NO_ECOMMERCE_COUNTER]: function (state) {
    state.noEcommerceCounter += 1
  },
  [UPDATE_LAST_WISHLIST_ITEM]: function (state, payload) {
    state.lastWishlistItem = payload.catEntry
  },
  [UPDATE_LAST_ADDTOBAG_ITEM]: function (state, payload) {
    state.lastAddToBagItem = payload.orderItemId
  },
  [SHOW_PICKUPSTORE]: function (state) {
    state.pickupStore.show = true
  },
  [HIDE_PICKUPSTORE]: function (state) {
    state.pickupStore.show = false
  },
  [SET_USER_SELF_DATA]: function (state, payload) {
    state.userSelfData = payload
  },
  [UPDATE_GOOGLE_MAP_DATA]: function (state, payload) {
    state.googleMapData = payload
  },
  [OPEN_FIND_IN_STORE_PANEL]: function (state) {
    state.findInStore.panelIsVisible = true
  },
  [CLOSE_FIND_IN_STORE_PANEL]: function (state) {
    state.findInStore.panelIsVisible = false
  },
  [OPEN_STORE_DETAILS_PANEL]: function (state) {
    state.findInStore.storeDetailsPanelIsVisible = true
  },
  [CLOSE_STORE_DETAILS_PANEL]: function (state) {
    state.findInStore.storeDetailsPanelIsVisible = false
  },
  [OPEN_EYEMED_MODAL_OR_PANEL]: function (state) {
    state.eyeMedIsVisible = true
  },
  [CLOSE_EYEMED_MODAL_OR_PANEL]: function (state) {
    state.eyeMedIsVisible = false
  },
  [UPDATE_PDP_DASH_BUTTON_SMALL]: function (state, payload) {
    state.ui.isDashButtonSmall = payload
  },
  [UPDATE_NEWSLETTER_OPEN_STATUS]: function (state, payload) {
    state.ui.newsletterOpenStatus = payload
  },

  [OPEN_AFTERPAY_MODAL_OR_PANEL]: function (state) {
    state.afterpayIsVisible = true
  },
  [CLOSE_AFTERPAY_MODAL_OR_PANEL]: function (state) {
    state.afterpayIsVisible = false
  },
  [LOCK_TRUST_PILOT_SCRIPT]: function (state) {
    state.isTrustPilotScriptLoaded = true
  },

  [ACTION_SET_PICKUP_STORE_TRUE]: function (state) {
    state.sidebar.cart.isPickupStore = true
  },
  [SET_GOOGLE_MAPS_SCRIPTS_STATUS]: function (state) {
    state.findInStore.googleMapsApiIsLoaded = true
  },
  [SHOW_PAYMENT_MESSAGE_BOX]: function (state) {
    state.sidebar.cart.showPaymentMessageBox = true
  },
  [HIDE_PAYMENT_MESSAGE_BOX]: function (state) {
    state.sidebar.cart.showPaymentMessageBox = false
  },
  [UPDATE_KLARNA_EXPRESS_LOADED_STATUS]: function (state, payload) {
    state.klarnaExpressScriptIsLoaded = payload
  },
  [UPDATE_KLARNA_EXPRESS_INITIALIZED]: function (state, payload) {
    state.klarnaIsInitialized = payload
  },
  [UPDATE_ROX_PANEL_OVERLAY]: function (state, payload) {
    state.roxPanelOverlay = payload.roxPanelOverlay
    state.roxPanelOverlayType = payload.roxPanelOverlayType
  },
}
